import { useEffect } from 'react';

const preventScroll = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
  return false;
};

export const useDisableScroll = (elements: Element[], disabled = true) => {
  useEffect(() => {
    if (disabled) {
      elements.forEach(element => {
        element.addEventListener('wheel', preventScroll, { passive: false });
      });
    }

    return () => {
      elements.forEach(element => {
        element.removeEventListener('wheel', preventScroll);
      });
    };
  }, [elements, disabled]);
};
